import { Shadows as ShadowsMui } from '@mui/material';

import Shadows from 'src/theme/light/shadows';

const shadows: ShadowsMui = Shadows;

export default shadows;
